import * as React from "react"

//https://react-svgr.com/playground/
function SvgIconTodosOn(props) {
    return (
        <svg
            width={244}
            height={244}
            viewBox="0 0 244 244"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx={122} cy={120} r={117} fill="#000" />
            <path
            d="M122.005 243.151C54.73 243.151 0 188.611 0 121.581 0 54.54 54.73 0 122.005 0 189.27 0 244 54.54 244 121.581c0 67.03-54.73 121.57-121.995 121.57zm0-236.342C58.492 6.809 6.823 58.299 6.823 121.59c0 63.282 51.669 114.771 115.182 114.771 63.503 0 115.172-51.489 115.172-114.771 0-63.293-51.669-114.782-115.172-114.782z"
            fill="#000"
            />
            <path
            d="M184.528 38.74c-1.16-10.628 6.573-20.168 17.216-21.324 10.664-1.157 20.228 6.52 21.388 17.146 1.161 10.607-6.532 20.167-17.196 21.314-10.644 1.156-20.248-6.53-21.408-17.137z"
            fill="#000"
            />
            <path
            d="M193.431 37.772c-.63-5.732 3.512-10.846 9.274-11.474 5.762-.628 10.894 3.489 11.514 9.221.62 5.712-3.501 10.846-9.263 11.474-5.753.628-10.894-3.509-11.525-9.22z"
            fill="#FFDD00"
            />
            <path
            d="M191.591 103.906v61.328c-.43 2.134-1.031 4.187-2.371 5.962-2.641 3.479-6.222 5.004-10.534 5.004h-41.835c-21.108 0-42.216 0-63.334-.01-5.272 0-9.373-2.133-11.654-6.968-.79-1.675-1.23-3.669-1.24-5.523-.08-27.025-.07-54.061-.04-81.087.01-5.971 3.5-10.497 9.283-12.042 1.57-.419 3.261-.409 5.052-.618l12.044.17h1.65c21.669 0 43.327-.01 64.995 0 .55 0 1.12.01 1.65.129.961.22 1.461.927 1.421 1.864-.04.997-.62 1.655-1.661 1.804-.46.06-.94.04-1.4.04H86.963l-12.015-.02c-6.082.05-10.514 3.001-10.534 8.773-.03 8.414-.01 16.827-.01 25.241v55.078c0 5.962 3.371 9.331 9.343 9.331 34.883 0 69.766.01 104.649.01 5.962 0 9.343-3.379 9.343-9.331 0-26.647-.01-32.359 0-59.006.04-.807.841-1.515 1.771-1.595 1.171-.089 2.081.319 2.081 1.466z"
            fill="#FFDD00"
            stroke="#FFDD00"
            strokeWidth={3}
            strokeMiterlimit={10}
            />
            <path
            d="M178.496 86.4l-68.175 67.938-22.609-22.529"
            stroke="#FFDD00"
            strokeWidth={7}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
            />
        </svg>
    )
}

export default SvgIconTodosOn;